export interface ZipFile { name: string; bytes: Uint8Array }

// ZIP's STORE format preserves the original compressed image/PDF bytes.
// UTF-8 names and standard headers make the archive readable by Finder and Windows.
export function productZip(files: ZipFile[]): Blob {
  if (files.length > 65535) throw new Error("För många filer för en ZIP-export.");
  const table = new Uint32Array(256);
  for (let i = 0; i < 256; i++) {
    let value = i;
    for (let bit = 0; bit < 8; bit++) value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
    table[i] = value;
  }
  const parts: BlobPart[] = [], directory: Uint8Array[] = [], names = new Set<string>();
  let offset = 0, directorySize = 0;
  files.forEach(({ name, bytes }) => {
    if (!name || name.includes("\\") || Array.from(name).some((character) => character.charCodeAt(0) < 32) || name.startsWith("/") || name.split("/").some((part) => !part || part === "." || part === "..") || names.has(name)) {
      throw new Error("ZIP-filen innehåller ett ogiltigt eller dubblerat filnamn.");
    }
    names.add(name);
    const encoded = new TextEncoder().encode(name);
    if (encoded.length > 65535 || bytes.length > 0xffffffff || offset + bytes.length + encoded.length + 30 > 0xffffffff) throw new Error("ZIP-filen är för stor.");
    let crc = 0xffffffff;
    for (let i = 0; i < bytes.length; i++) crc = table[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    crc = (crc ^ 0xffffffff) >>> 0;
    const local = new Uint8Array(30 + encoded.length), header = new DataView(local.buffer);
    header.setUint32(0, 0x04034b50, true); header.setUint16(4, 20, true); header.setUint16(6, 0x0800, true);
    header.setUint16(12, 33, true); // 1980-01-01; no fabricated upload timestamp.
    header.setUint32(14, crc, true); header.setUint32(18, bytes.length, true); header.setUint32(22, bytes.length, true);
    header.setUint16(26, encoded.length, true); local.set(encoded, 30);
    const central = new Uint8Array(46 + encoded.length), entry = new DataView(central.buffer);
    entry.setUint32(0, 0x02014b50, true); entry.setUint16(4, 20, true); entry.setUint16(6, 20, true); entry.setUint16(8, 0x0800, true);
    entry.setUint16(14, 33, true); entry.setUint32(16, crc, true); entry.setUint32(20, bytes.length, true); entry.setUint32(24, bytes.length, true);
    entry.setUint16(28, encoded.length, true); entry.setUint32(42, offset, true); central.set(encoded, 46);
    parts.push(local, bytes); directory.push(central); directorySize += central.length; offset += local.length + bytes.length;
  });
  if (offset + directorySize + 22 > 0xffffffff) throw new Error("ZIP-filen är för stor.");
  const end = new Uint8Array(22), footer = new DataView(end.buffer);
  footer.setUint32(0, 0x06054b50, true); footer.setUint16(8, files.length, true); footer.setUint16(10, files.length, true);
  footer.setUint32(12, directorySize, true); footer.setUint32(16, offset, true);
  return new Blob([...parts, ...directory, end], { type: "application/zip" });
}
